import i18next from "i18next";

export const parseData = (data: Array<any>) => {
  return data.map((item: any) => ({
    name: item.name,
    isActive: item.isActive,
    id: item.id,
  }));
};
